var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FieldType, } from "@brushfire/types";
import React, { useEffect, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCartData, updateCartData, updateQuestionsData, setQuestionsData, updateCartStatus, } from "../../../../../store/Cart/actions";
import CartQuestionForm from "./CartQuestionForm";
import { IconButton, FadeSection, Alert } from "@brushfire/ui";
import { useIntl } from "react-intl";
import { clearInlineErrors, setInlineError, setFormIsSubmitting } from "../../../../../store/AppState/actions";
import Skeleton from "@material-ui/lab/Skeleton";
import { AppFormContext } from "../../../../../App";
import { deleteAttendee, postAttendeeQuestions, postBuyerQuestions, getQuestions, clearCart, } from "../../../../../data/api";
import { convertToFieldViews, handleErrors, isVisible } from "../../../../../data/helpers";
import Constants from "../../../../../data/constants";
import { useParams } from "react-router-dom";
import CartSummary from "./CartSummary";
import CartCheckout from "./CartCheckout";
import { isEmpty, isEqual } from "lodash";
import { Col, Row } from "react-bootstrap";
import useWidgetHistory from "../../../../../hooks/useWidgetHistory";
import { addSubmittedForm, clearSubmittedForms } from "../../../../../store/Record/actions";
import WidgetSticky from "../../../../Helpers/WidgetSticky";
import AttendeeCartItem from "./AttendeeCartItem";
import CartItems from "./CartItems";
import { useMediaQuery } from "react-responsive";
import { Carousel } from "react-responsive-carousel";
import AttendeeCartHeader from "./AttendeeCartHeader";
import StatusIndicator from "../../../../UI/StatusIndicator";
import useWidgetAnalytics from "../../../../../hooks/useWidgetAnalytics";
import { integrationsEventBuyerFieldsPosted } from "../../../../../store/Integrations/actions";
import moment from "moment";
import { getLocal, LOCAL_STORAGE_KEYS } from "../../../../../data/localStorageHelpers";
var useTypedSelector = useSelector;
var Cart = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var theme = _a.theme, eventData = _a.eventData, path = _a.path, cartTotalSeen = _a.cartTotalSeen, setCartTotalSeen = _a.setCartTotalSeen;
    var _s = __read(useState(), 2), selectedQuestion = _s[0], setSelectedQuestion = _s[1];
    var _t = __read(useState(0), 2), stickyCounter = _t[0], setStickyCounter = _t[1];
    var _u = __read(useState(false), 2), isSaving = _u[0], setIsSaving = _u[1];
    var _v = __read(useState(true), 2), showForm = _v[0], setShowForm = _v[1];
    var _w = __read(useState(""), 2), editQuestionId = _w[0], setEditQuestionId = _w[1];
    var _x = __read(useState(), 2), showRemoveAttendeeModal = _x[0], setShowRemoveAttendeeModal = _x[1];
    var _y = __read(useState(false), 2), setRemovingAttendee = _y[1];
    var _z = __read(useState(true), 2), showQuestion = _z[0], setShowQuestion = _z[1];
    var _0 = __read(useState(false), 2), hideQuestion = _0[0], setHideQuestion = _0[1];
    var _1 = __read(useState(true), 2), showSummary = _1[0], setShowSummary = _1[1];
    var _2 = __read(useState(true), 1), hideSummary = _2[0];
    var _3 = __read(useState(), 2), startSwipe = _3[0], setStartSwipe = _3[1];
    var _4 = __read(useState(false), 1), enableDynamicHeight = _4[0];
    var _5 = __read(useState(), 2), valuesToResetTo = _5[0], setValuesToResetTo = _5[1];
    var _6 = __read(React.useState(), 2), remainingTime = _6[0], setRemainingTime = _6[1];
    var _7 = __read(React.useState(false), 2), isTimerReady = _7[0], setIsTimerReady = _7[1];
    var scrollPoint = useRef(null);
    var isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    var event = useTypedSelector(function (store) { return store.events; }).event;
    var _8 = useTypedSelector(function (store) { return store.cart; }), cart = _8.cart, questions = _8.questions, questionsStatus = _8.questionsStatus, cartStatus = _8.cartStatus;
    var questionSubmitHistory = useTypedSelector(function (store) { return store.record; }).questionSubmitHistory;
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var params = useParams();
    var intl = useIntl();
    var analytics = useWidgetAnalytics();
    var buyerForm = questions === null || questions === void 0 ? void 0 : questions.find(function (f) { return !f.isAttendee; });
    var attendeeForms = questions === null || questions === void 0 ? void 0 : questions.filter(function (f) { return f.isAttendee; }).sort(function (a, b) {
        var _a, _b;
        return cart
            ? ((_a = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _a === void 0 ? void 0 : _a.findIndex(function (c) { return c.attendeeId === a.id; })) -
                ((_b = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _b === void 0 ? void 0 : _b.findIndex(function (c) { return c.attendeeId === b.id; }))
            : 0;
    });
    var formikContext = useContext(AppFormContext).formikContext;
    var isCart = path === Constants.Routes.cart;
    var isCheckout = path === Constants.Routes.checkout;
    var isMatrix = [Constants.Routes.tickets, Constants.Routes.register, Constants.Routes.autoreg].includes(path);
    var currentCartFormValues = (_d = (_c = (_b = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _b === void 0 ? void 0 : _b.formikRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.values;
    useEffect(function () {
        if (cart === null || cart === void 0 ? void 0 : cart.expiresAt) {
            var expirationTime_1 = moment(cart.expiresAt);
            var timeLeft_1 = moment(expirationTime_1.diff(moment()));
            var expired = timeLeft_1.minutes() === 0 && timeLeft_1.seconds() === 0;
            if (!expired) {
                setRemainingTime(timeLeft_1.format("mm:ss"));
                setIsTimerReady(true);
            }
            var cartTimerInterval_1 = setInterval(function () {
                timeLeft_1 = moment(expirationTime_1.diff(moment()));
                if (expirationTime_1.isBefore(moment())) {
                    setRemainingTime("00:00");
                }
                else if (timeLeft_1.minutes() !== 0 || timeLeft_1.seconds() !== 0) {
                    setRemainingTime(timeLeft_1.format("mm:ss"));
                }
                else {
                    setRemainingTime("00:00");
                }
            }, 1000);
            return function () {
                clearInterval(cartTimerInterval_1);
            };
        }
        setIsTimerReady(true);
    }, [cart === null || cart === void 0 ? void 0 : cart.expiresAt]);
    useEffect(function () {
        if (currentCartFormValues) {
            setTimeout(function () {
                setValuesToResetTo(currentCartFormValues);
            }, 400);
        }
    }, [isMobile]);
    useEffect(function () {
        if (valuesToResetTo && formikContext) {
            formikContext === null || formikContext === void 0 ? void 0 : formikContext.resetForm({ values: valuesToResetTo });
            setValuesToResetTo(undefined);
        }
    }, [valuesToResetTo]);
    useEffect(function () {
        if ((cart === null || cart === void 0 ? void 0 : cart.cartId) && eventData && questions && !isCart && !isCheckout) {
            var updatedQuestions = questions.concat();
            var currentQuestion = updatedQuestions.find(function (a) { return a.id === selectedQuestion || (cart === null || cart === void 0 ? void 0 : cart.cartId) === selectedQuestion; });
            if (!selectedQuestion) {
                if (params.attendeeId) {
                    setSelectedQuestion(params.attendeeId);
                }
                else {
                    var nextId = getNextId();
                    setSelectedQuestion(nextId);
                }
            }
            else {
                if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.canContinue) || editQuestionId || !currentQuestion) {
                    var nextId = getNextId();
                    if (!nextId) {
                        var originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(cart.eventNumber));
                        continueToCheckout(!!originalOrderId && cart.addonCount > 0);
                    }
                    setNextQuestion(nextId);
                }
            }
        }
    }, [cart === null || cart === void 0 ? void 0 : cart.cartId, eventData === null || eventData === void 0 ? void 0 : eventData.id, questions]);
    var getNextId = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var firstIncomplete = (_a = attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.find(function (a) {
            return a.fields.length > 0 &&
                !(questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(a.id)) &&
                !(a.isPreRegistered && isAutoRegMode);
        })) === null || _a === void 0 ? void 0 : _a.id;
        if (editQuestionId) {
            return editQuestionId;
        }
        else if (cart &&
            (!(buyerForm === null || buyerForm === void 0 ? void 0 : buyerForm.canContinue) || !(questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(cart.cartId))) &&
            ((_b = buyerForm === null || buyerForm === void 0 ? void 0 : buyerForm.fields.length) !== null && _b !== void 0 ? _b : 0) > 0) {
            return cart.cartId;
        }
        else {
            var index = attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.findIndex(function (a) { return a.id === selectedQuestion; });
            if (firstIncomplete && index && event && cart) {
                var oldIndex = (_c = cart.attendees) === null || _c === void 0 ? void 0 : _c.findIndex(function (a) { return a.attendeeId === selectedQuestion; });
                var newIndex = (_d = cart.attendees) === null || _d === void 0 ? void 0 : _d.findIndex(function (a) { return a.attendeeId === firstIncomplete; });
                if (newIndex && oldIndex && newIndex - oldIndex > 1) {
                    for (var i = oldIndex + 1; i < newIndex; i++) {
                        dispatch(addSubmittedForm({
                            eventNumber: event.eventNumber,
                            formId: cart.attendees[i].attendeeId,
                        }));
                    }
                }
            }
            if (attendeeForms) {
                if (buyerForm === null || buyerForm === void 0 ? void 0 : buyerForm.canContinue) {
                    if (cart === null || cart === void 0 ? void 0 : cart.attendees.every(function (a) { return a.isPreRegistered && isAutoRegMode; })) {
                        return undefined;
                    }
                    return ((_f = firstIncomplete !== null && firstIncomplete !== void 0 ? firstIncomplete : (_e = cart === null || cart === void 0 ? void 0 : cart.attendees.find(function (a) {
                        return !(questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(a.attendeeId)) &&
                            !(a.isPreRegistered && isAutoRegMode) &&
                            !a.canContinue;
                    })) === null || _e === void 0 ? void 0 : _e.attendeeId) !== null && _f !== void 0 ? _f : (_g = attendeeForms[index !== undefined && index >= 0 ? index + 1 : 0]) === null || _g === void 0 ? void 0 : _g.id //
                    );
                }
                return firstIncomplete !== null && firstIncomplete !== void 0 ? firstIncomplete : (_h = attendeeForms[index !== undefined && index >= 0 ? index + 1 : 0]) === null || _h === void 0 ? void 0 : _h.id;
            }
            else {
                return undefined;
            }
        }
    };
    useEffect(function () {
        if (path !== Constants.Routes.questions && selectedQuestion) {
            var nextId = getNextId();
            setSelectedQuestion(nextId);
        }
    }, [questions === null || questions === void 0 ? void 0 : questions.length]);
    useEffect(function () {
        if (editQuestionId) {
            if (formikContext === null || formikContext === void 0 ? void 0 : formikContext.dirty) {
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.submitForm();
            }
            else {
                if (params.attendeeId && eventData) {
                    var url = Constants.Routes.questions
                        .replace(":clientKey", eventData.clientKey)
                        .replace(":urlKey", eventData.urlKey)
                        .replace(":eventNumber", eventData.eventNumber.toString())
                        .replace(Constants.Regex.guid, "")
                        .replace(":attendeeId", editQuestionId);
                    history.push(url);
                    setEditQuestionId("");
                }
                else {
                    setSelectedQuestion(editQuestionId);
                }
            }
        }
    }, [editQuestionId]);
    useEffect(function () {
        if (formikContext === null || formikContext === void 0 ? void 0 : formikContext.isSubmitting) {
            setShowQuestion(true);
        }
        else if (isCart) {
            setShowQuestion(false);
        }
    }, [formikContext === null || formikContext === void 0 ? void 0 : formikContext.isSubmitting]);
    var assessedQuestionId = selectedQuestion !== null && selectedQuestion !== void 0 ? selectedQuestion : params.attendeeId;
    var setNextQuestion = function (id) {
        setSelectedQuestion(undefined);
        setTimeout(function () {
            setIsSaving(false);
            setSelectedQuestion(id);
            setTimeout(function () {
                setTimeout(function () {
                    setStickyCounter(stickyCounter + 1);
                }, 300);
                setTimeout(function () {
                    var _a;
                    setShowForm(false);
                    (_a = scrollPoint.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
                    setShowForm(true);
                }, 500);
            }, 300);
        }, 300);
    };
    var shouldContinueToCheckout = function () {
        var newQuestions = questions === null || questions === void 0 ? void 0 : questions.concat();
        var currentForm = attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.find(function (a) { return a.id === selectedQuestion; });
        if (!cart || !newQuestions) {
            return false;
        }
        return newQuestions.every(function (q) {
            var _a;
            if (q.attendeeNumber === 0) {
                return q.canContinue;
            }
            else {
                var attendeeId = (_a = cart.attendees.find(function (a) { return a.attendeeNumber === q.attendeeNumber; })) === null || _a === void 0 ? void 0 : _a.attendeeId;
                if (!attendeeId || q.fields.length === 0 || q.id === (currentForm === null || currentForm === void 0 ? void 0 : currentForm.id)) {
                    return true;
                }
                return ((questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(attendeeId)) || (q.isPreRegistered && isAutoRegMode));
            }
        });
    };
    var submitQuestions = function (values, formikHelpers) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var cleanedValues = Object.assign({}, values);
        (_a = Object.keys(cleanedValues)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            var _a, _b, _c, _d;
            if (key === "isGift" || key === "recipientEmail" || key === "isPreRegistered" || key === "copyToAll") {
                delete cleanedValues[key];
            }
            else {
                if (Array.isArray(cleanedValues[key])) {
                    cleanedValues[key] = cleanedValues[key].filter(function (x) { return !!x; });
                    if (cleanedValues[key].some(function (x) { return !!x.price; })) {
                        var v = intl.formatNumberToParts(1000.0, {
                            style: "currency",
                            currency: (_a = event === null || event === void 0 ? void 0 : event.currency) !== null && _a !== void 0 ? _a : "USD",
                        });
                        var symbol_1 = ((_b = v.find(function (x) { return x.type === "currency"; })) === null || _b === void 0 ? void 0 : _b.value) || "$";
                        var isCommaDecimal_1 = ((_c = v.find(function (x) { return x.type === "decimal"; })) === null || _c === void 0 ? void 0 : _c.value) === ",";
                        (_d = cleanedValues[key]) === null || _d === void 0 ? void 0 : _d.forEach(function (opt) {
                            var _a, _b;
                            if (isNaN(opt.price)) {
                                opt.price = opt.price
                                    ? opt.price === ""
                                        ? 0
                                        : isCommaDecimal_1
                                            ? parseFloat(((_a = opt.price) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, "").replace(",", ".").replace(symbol_1 || "$", "")) || "0.00")
                                            : parseFloat(((_b = opt.price) === null || _b === void 0 ? void 0 : _b.replace(/\s+/g, "").replace(symbol_1 || "$", "")) || "0.00")
                                    : 0;
                            }
                        });
                    }
                }
            }
        });
        if ((cart === null || cart === void 0 ? void 0 : cart.cartId) && assessedQuestionId) {
            dispatch(setFormIsSubmitting(true));
            setIsSaving(true);
            if ((cart === null || cart === void 0 ? void 0 : cart.cartId) === assessedQuestionId) {
                var fieldViews_1 = convertToFieldViews((_b = buyerForm === null || buyerForm === void 0 ? void 0 : buyerForm.fields) !== null && _b !== void 0 ? _b : []);
                Object.keys(cleanedValues).forEach(function (id) {
                    var field = fieldViews_1.find(function (field) { return field.id === id || field.childFields.some(function (child) { return child.id === id; }); });
                    if (!field ||
                        !isVisible(field, values, fieldViews_1) ||
                        [
                            FieldType[FieldType.Paragraph],
                            FieldType[FieldType.SectionHeader],
                            FieldType[FieldType.Link],
                        ].includes(field.type)) {
                        delete cleanedValues[id];
                    }
                });
                var payload = {
                    fields: Object.keys(cleanedValues).map(function (key) { return ({ id: key, value: cleanedValues[key] }); }),
                };
                dispatch(integrationsEventBuyerFieldsPosted(Object.keys(cleanedValues).map(function (key) {
                    var _a, _b;
                    return ({
                        id: key,
                        value: cleanedValues[key],
                        label: (_b = (_a = fieldViews_1.find(function (field) { return field.id === key; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "nolabel",
                    });
                })));
                postBuyerQuestions(cart === null || cart === void 0 ? void 0 : cart.cartId, payload)
                    .then(function (_a) {
                    var data = _a.data;
                    if (event === null || event === void 0 ? void 0 : event.eventNumber) {
                        dispatch(addSubmittedForm({
                            eventNumber: event === null || event === void 0 ? void 0 : event.eventNumber,
                            formId: assessedQuestionId,
                        }));
                    }
                    dispatch(updateCartData(history.push));
                    if (editQuestionId) {
                        if (params.attendeeId && eventData) {
                            var url = Constants.Routes.questions
                                .replace(":clientKey", eventData.clientKey)
                                .replace(":urlKey", eventData.urlKey)
                                .replace(":eventNumber", eventData.eventNumber.toString())
                                .replace(Constants.Regex.guid, "")
                                .replace(":attendeeId", editQuestionId);
                            history.push(url);
                        }
                        else {
                            setSelectedQuestion(editQuestionId);
                        }
                    }
                    formikHelpers.resetForm({ values: values });
                    var newQuestions = questions === null || questions === void 0 ? void 0 : questions.concat();
                    var updatedIndex = newQuestions === null || newQuestions === void 0 ? void 0 : newQuestions.findIndex(function (q) { return q.id === data.id; });
                    if (newQuestions && updatedIndex !== undefined && updatedIndex >= 0) {
                        newQuestions[updatedIndex] = data;
                    }
                    dispatch(setQuestionsData(newQuestions));
                    var shouldContinue = shouldContinueToCheckout();
                    if (shouldContinue && !editQuestionId) {
                        var originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(cart.eventNumber));
                        continueToCheckout(!!originalOrderId && cart.addonCount > 0);
                    }
                })
                    .catch(function (err) {
                    if (formikContext) {
                        handleErrors(err, dispatch, formikContext);
                    }
                })
                    .finally(function () {
                    setTimeout(function () {
                        setIsSaving(false);
                        formikHelpers.setSubmitting(false);
                        dispatch(setFormIsSubmitting(false));
                    }, 500);
                });
            }
            else {
                var fieldViews_2 = convertToFieldViews((_d = (_c = attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.find(function (attendeeForm) { return attendeeForm.id === assessedQuestionId; })) === null || _c === void 0 ? void 0 : _c.fields) !== null && _d !== void 0 ? _d : []);
                Object.keys(cleanedValues).forEach(function (id) {
                    var field = fieldViews_2.find(function (field) { return field.id === id || field.childFields.some(function (child) { return child.id === id; }); });
                    if (!field ||
                        !isVisible(field, values, fieldViews_2) ||
                        [
                            FieldType[FieldType.Paragraph],
                            FieldType[FieldType.SectionHeader],
                            FieldType[FieldType.Link],
                        ].includes(field.type)) {
                        delete cleanedValues[id];
                    }
                });
                var payload = {
                    fields: Object.keys(cleanedValues).map(function (key) { return ({ id: key, value: cleanedValues[key] }); }),
                    isGift: (_e = values.isGift) !== null && _e !== void 0 ? _e : false,
                    isPreRegistered: (_f = values.isPreRegistered) !== null && _f !== void 0 ? _f : false,
                    recipientEmail: (_g = values.recipientEmail) !== null && _g !== void 0 ? _g : null,
                    copyToAll: (_h = values.copyToAll) !== null && _h !== void 0 ? _h : false,
                };
                postAttendeeQuestions(cart === null || cart === void 0 ? void 0 : cart.cartId, assessedQuestionId, payload)
                    .then(function (_a) {
                    var data = _a.data;
                    if (event === null || event === void 0 ? void 0 : event.eventNumber) {
                        dispatch(addSubmittedForm({
                            eventNumber: event === null || event === void 0 ? void 0 : event.eventNumber,
                            formId: assessedQuestionId,
                        }));
                        if (values.copyToAll && !values.isPreRegistered) {
                            var currentForm_1 = attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.find(function (a) { return a.id === selectedQuestion; });
                            if (currentForm_1) {
                                attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.forEach(function (form) {
                                    if (form.copyableAttendeeNumbers.includes(currentForm_1.attendeeNumber)) {
                                        dispatch(addSubmittedForm({
                                            eventNumber: event === null || event === void 0 ? void 0 : event.eventNumber,
                                            formId: form.id,
                                        }));
                                    }
                                });
                            }
                        }
                        else if (values.copyToAll && values.isPreRegistered) {
                            var currentForm = attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.find(function (a) { return a.id === selectedQuestion; });
                            if (currentForm) {
                                var currentFormFields_1 = currentForm.fields.map(function (field) { return field.id; });
                                attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.forEach(function (form) {
                                    if (form.preRegEnabled &&
                                        isEqual(form.fields.map(function (field) { return field.id; }), currentFormFields_1)) {
                                        dispatch(addSubmittedForm({
                                            eventNumber: event === null || event === void 0 ? void 0 : event.eventNumber,
                                            formId: form.id,
                                        }));
                                    }
                                });
                            }
                        }
                    }
                    dispatch(updateCartData(history.push));
                    if (editQuestionId &&
                        (!(cart.canContinue &&
                            cart.attendees.every(function (attendee) {
                                return (questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(attendee.attendeeId)) ||
                                    attendee.id === selectedQuestion ||
                                    (attendee.isPreRegistered && isAutoRegMode);
                            })) ||
                            params.attendeeId)) {
                        if (editQuestionId) {
                            if (params.attendeeId && eventData) {
                                var url = Constants.Routes.questions
                                    .replace(":clientKey", eventData.clientKey)
                                    .replace(":urlKey", eventData.urlKey)
                                    .replace(":eventNumber", eventData.eventNumber.toString())
                                    .replace(Constants.Regex.guid, "")
                                    .replace(":attendeeId", editQuestionId);
                                history.push(url);
                            }
                            else {
                                setSelectedQuestion(editQuestionId);
                            }
                        }
                        if (values.copyToAll) {
                            dispatch(updateQuestionsData(function () { return null; }));
                        }
                    }
                    else {
                        if (values.copyToAll) {
                            dispatch(updateQuestionsData(history.push));
                        }
                    }
                    formikHelpers.resetForm({ values: values });
                    if (!values.copyToAll) {
                        var newQuestions = questions === null || questions === void 0 ? void 0 : questions.concat();
                        var updatedIndex = newQuestions === null || newQuestions === void 0 ? void 0 : newQuestions.findIndex(function (q) { return q.id === data.id; });
                        if (newQuestions && updatedIndex !== undefined && updatedIndex >= 0) {
                            newQuestions[updatedIndex] = data;
                        }
                        dispatch(setQuestionsData(newQuestions));
                        if (shouldContinueToCheckout() && !editQuestionId) {
                            var originalOrderId = getLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(cart.eventNumber));
                            continueToCheckout(!!originalOrderId && cart.addonCount > 0);
                        }
                    }
                })
                    .catch(function (err) {
                    if (formikContext) {
                        handleErrors(err, dispatch, formikContext);
                    }
                })
                    .finally(function () {
                    setTimeout(function () {
                        setIsSaving(false);
                        formikHelpers.setSubmitting(false);
                        dispatch(setFormIsSubmitting(false));
                    }, 500);
                });
            }
        }
    };
    var handleEditQuestion = function (attendeeId) {
        setShowQuestion(true);
        if (questions && event) {
            var clientKey = event.clientKey, urlKey = event.urlKey, eventNumber = event.eventNumber;
            if (window.location.pathname ===
                Constants.Routes.cart
                    .replace(":clientKey", clientKey)
                    .replace(":urlKey", urlKey)
                    .replace(":eventNumber", eventNumber.toString())
            // || params.attendeeId
            ) {
                var url = Constants.Routes.questions
                    .replace(":clientKey", clientKey)
                    .replace(":urlKey", urlKey)
                    .replace(":eventNumber", eventNumber.toString())
                    .replace(Constants.Regex.guid, "")
                    .replace(":attendeeId", attendeeId);
                history.push(url);
            }
            if (selectedQuestion || params.attendeeId) {
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.validateForm().then(function (errors) {
                    if (isEmpty(errors) || !formikContext.dirty) {
                        setEditQuestionId(attendeeId);
                    }
                    else {
                        //just trigger validation error ui
                        formikContext === null || formikContext === void 0 ? void 0 : formikContext.submitForm();
                    }
                });
            }
            else {
                setSelectedQuestion(attendeeId);
            }
        }
    };
    var continueToCheckout = function (forceCart) {
        if (forceCart === void 0) { forceCart = false; }
        if (eventData) {
            setSelectedQuestion(undefined);
            var clientKey = eventData.clientKey, urlKey = eventData.urlKey, eventNumber = eventData.eventNumber, addOns = eventData.addOns;
            if (![Constants.Routes.addons, Constants.Routes.cart].includes(path)) {
                var url = (addOns.filter(function (a) { return a.isAvailable; }).length > 0 &&
                    path !== Constants.Routes.addons &&
                    !forceCart
                    ? Constants.Routes.addons
                    : Constants.Routes.cart)
                    .replace(":clientKey", clientKey)
                    .replace(":urlKey", urlKey)
                    .replace(":eventNumber", eventNumber.toString());
                history.push(url, undefined, false);
            }
        }
    };
    var resetMobileFlow = function () {
        setShowSummary(true);
        setShowQuestion(false);
    };
    var handleDeleteAttendee = function (values, formikHelpers) {
        var _a, _b, _c;
        var attendeeToDeleteIsAddon = (_a = cart === null || cart === void 0 ? void 0 : cart.attendees.find(function (a) { return a.attendeeId === showRemoveAttendeeModal; })) === null || _a === void 0 ? void 0 : _a.isAddon;
        if ((cart === null || cart === void 0 ? void 0 : cart.attendees.filter(function (a) { return !a.isAddon; }).length) === 1 && !attendeeToDeleteIsAddon) {
            dispatch(clearInlineErrors());
            dispatch(setFormIsSubmitting(true));
            if (cart) {
                clearCart(cart.cartId, (_b = event === null || event === void 0 ? void 0 : event.eventNumber.toString()) !== null && _b !== void 0 ? _b : "")
                    .then(function () {
                    resetMobileFlow();
                    dispatch(updateCartData(history.replace));
                    if (cart && event) {
                        dispatch(clearSubmittedForms(event.eventNumber.toString()));
                        analytics.removeFromCart(cart.attendees, event);
                    }
                    setCartTotalSeen(false);
                })
                    .catch(function (err) {
                    var _a;
                    if (err.response.status !== 404) {
                        dispatch(setInlineError({ clearCartError: (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.message }));
                    }
                    else {
                        resetMobileFlow();
                        dispatch(updateCartData(history.replace));
                        if (cart && event) {
                            dispatch(clearSubmittedForms(event.eventNumber.toString()));
                            analytics.removeFromCart(cart.attendees, event);
                        }
                        setCartTotalSeen(false);
                    }
                })
                    .finally(function () {
                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setSubmitting(false);
                    dispatch(setFormIsSubmitting(false));
                    setShowRemoveAttendeeModal(undefined);
                });
            }
        }
        else {
            var attendeeId_1 = showRemoveAttendeeModal;
            dispatch(setFormIsSubmitting(true));
            if (cart && attendeeId_1 && event) {
                var clientKey_1 = event.clientKey, urlKey_1 = event.urlKey, eventNumber_1 = event.eventNumber;
                dispatch(clearInlineErrors());
                setRemovingAttendee(true);
                deleteAttendee(cart.cartId, attendeeId_1, (_c = event === null || event === void 0 ? void 0 : event.eventNumber.toString()) !== null && _c !== void 0 ? _c : "")
                    .then(function (_a) {
                    var _b;
                    var data = _a.data;
                    var cartData = data;
                    dispatch(updateCartStatus({ isLoading: true, timesLoaded: cartStatus.timesLoaded }));
                    if (!cartData) {
                        dispatch(setCartData(cartData));
                        var url = (isAutoRegMode
                            ? Constants.Routes.autoreg
                            : event.verbiage === "Tickets"
                                ? Constants.Routes.tickets
                                : Constants.Routes.register)
                            .replace(":clientKey", clientKey_1)
                            .replace(":urlKey", urlKey_1)
                            .replace(":eventNumber", eventNumber_1.toString());
                        dispatch(setCartData(undefined));
                        dispatch(setFormIsSubmitting(false));
                        resetMobileFlow();
                        history.push(url);
                        setShowRemoveAttendeeModal(undefined);
                    }
                    else {
                        if (cartData.canContinue && ((_b = cartData.attendees) === null || _b === void 0 ? void 0 : _b.every(function (a) { return a.canContinue; }))) {
                            dispatch(setCartData(cartData));
                            setRemovingAttendee(false);
                            continueToCheckout();
                            getQuestions(cartData.cartId, cartData.eventNumber.toString()).then(function (_a) {
                                var data = _a.data;
                                dispatch(setQuestionsData(data));
                                dispatch(setFormIsSubmitting(false));
                                formikHelpers.setSubmitting(false);
                                setShowRemoveAttendeeModal(undefined);
                            });
                        }
                        else {
                            getQuestions(cartData.cartId, cartData.eventNumber.toString()).then(function (_a) {
                                var data = _a.data;
                                dispatch(setCartData(cartData));
                                dispatch(setQuestionsData(data));
                                setShowRemoveAttendeeModal(undefined);
                                setRemovingAttendee(false);
                                dispatch(setFormIsSubmitting(false));
                                formikHelpers.setSubmitting(false);
                                setShowRemoveAttendeeModal(undefined);
                            });
                        }
                    }
                    var attendeeToRemove = cart.attendees.find(function (a) { return a.attendeeId === attendeeId_1; });
                    if (attendeeToRemove && eventData) {
                        analytics.removeFromCart([attendeeToRemove], eventData);
                    }
                })
                    .catch(function (err) {
                    var _a;
                    var _b, _c;
                    dispatch(setInlineError((_a = {},
                        _a["cart_remove_".concat(attendeeId_1)] = (_c = (_b = err.response.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "An error occured while removing this attendee",
                        _a)));
                    setShowRemoveAttendeeModal(undefined);
                    setRemovingAttendee(false);
                    dispatch(setFormIsSubmitting(false));
                    formikHelpers.setSubmitting(false);
                })
                    .finally(function () {
                    dispatch(updateCartStatus({ isLoading: false, timesLoaded: cartStatus.timesLoaded + 1 }));
                });
            }
        }
    };
    useEffect(function () {
        setEditQuestionId("");
        setTimeout(function () {
            setIsSaving(false);
        }, 500);
    }, [selectedQuestion]);
    useEffect(function () {
        if (params.attendeeId && selectedQuestion) {
            setSelectedQuestion(params.attendeeId);
        }
    }, [params]);
    useEffect(function () {
        if (cart !== undefined) {
            if (!isCart && path !== Constants.Routes.questions) {
                setSelectedQuestion(undefined);
            }
            else {
                if (event && !(cart === null || cart === void 0 ? void 0 : cart.attendees)) {
                    var clientKey = event.clientKey, urlKey = event.urlKey, eventNumber = event.eventNumber;
                    history.push((isAutoRegMode
                        ? Constants.Routes.autoreg
                        : (event === null || event === void 0 ? void 0 : event.verbiage) === "Tickets"
                            ? Constants.Routes.tickets
                            : Constants.Routes.register)
                        .replace(":clientKey", clientKey)
                        .replace(":urlKey", urlKey)
                        .replace(":eventNumber", eventNumber.toString()));
                }
                else if (!selectedQuestion) {
                    setSelectedQuestion(getNextId());
                }
            }
        }
    }, [isCart, cart]);
    useEffect(function () {
        if (showQuestion) {
            setHideQuestion(false);
        }
        else {
            setTimeout(function () {
                setHideQuestion(true);
            }, 450);
        }
    }, [showQuestion]);
    var getMobileIndex = function () {
        if (isCheckout) {
            return 4;
        }
        else if (isCart) {
            if (showSummary) {
                return 3;
            }
            return 2;
        }
        else if (showQuestion) {
            return 1;
        }
        else {
            return 0;
        }
    };
    var mobileIndex = getMobileIndex();
    useEffect(function () {
        var _a;
        if (isMobile &&
            ![
                Constants.Routes.tickets,
                Constants.Routes.register,
                Constants.Routes.details,
                Constants.Routes.autoreg,
            ].includes(path)) {
            (_a = scrollPoint.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
        }
    }, [mobileIndex, params.attendeeId]);
    useEffect(function () {
        var _a;
        if (!isMobile &&
            ![
                Constants.Routes.tickets,
                Constants.Routes.register,
                Constants.Routes.details,
                Constants.Routes.autoreg,
            ].includes(path)) {
            (_a = scrollPoint.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
        }
    }, [path, params.attendeeId]);
    var currentCartAttendee = (_e = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _e === void 0 ? void 0 : _e.find(function (attendee) { return attendee.attendeeId === assessedQuestionId; });
    var mobileGoBack = function () {
        var index = getMobileIndex();
        switch (index) {
            case 4:
                setShowSummary(true);
                continueToCheckout(true);
                break;
            case 3:
                setShowSummary(false);
                break;
            case 1:
                setShowQuestion(false);
                break;
        }
    };
    var isUsingSquare = ((_f = cart === null || cart === void 0 ? void 0 : cart.paymentProfile) === null || _f === void 0 ? void 0 : _f.gatewayId) === Constants.Gateways.GATEWAY_SQUARE ||
        ((_g = cart === null || cart === void 0 ? void 0 : cart.paymentProfile) === null || _g === void 0 ? void 0 : _g.gatewayId) === Constants.Gateways.GATEWAY_SQUARE_SANDBOX;
    var widgetPaymentRequest = cart
        ? {
            total: cart.total,
            cartId: cart.id,
            paymentMethods: cart.paymentMethods,
            paymentProfile: cart.paymentProfile,
            currency: isUsingSquare
                ? (_j = (_h = cart.paymentProfile) === null || _h === void 0 ? void 0 : _h.config) === null || _j === void 0 ? void 0 : _j.currency
                : (_m = (_l = (_k = cart.paymentProfile) === null || _k === void 0 ? void 0 : _k.options) === null || _l === void 0 ? void 0 : _l.currency) !== null && _m !== void 0 ? _m : "USD",
            country: cart.clientCountry,
            lineItems: (_p = (_o = cart.attendees) === null || _o === void 0 ? void 0 : _o.map(function (att) { return ({
                amount: att.unitTotal,
                label: att.attendeeDisplay.line1,
                pending: false,
            }); })) !== null && _p !== void 0 ? _p : [],
            deliveryMethods: cart.deliveryMethods,
            clientName: (_q = eventData === null || eventData === void 0 ? void 0 : eventData.clientName) !== null && _q !== void 0 ? _q : "",
            referenceOrders: {},
            shippingId: (_r = cart.shippingId) !== null && _r !== void 0 ? _r : undefined,
        }
        : undefined;
    var renderCartTimeoutAlert = function () {
        if ((cart === null || cart === void 0 ? void 0 : cart.expiresAt) && isTimerReady) {
            return _jsxs(Alert, __assign({ purpose: "info" }, { children: [remainingTime, " Remaining"] }));
        }
        return null;
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "cart cart-".concat(isCheckout || isCart ? "checkout" : "questions", " ").concat((!isCheckout && !isCart && showQuestion) || ((isCheckout || isCart) && showSummary) ? "active" : "") }, { children: [_jsx("div", { ref: scrollPoint, id: "form-top" }), !isMobile ? (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "cart-left", id: "cart-left" }, { children: [_jsx(FadeSection, __assign({ fade: path !== Constants.Routes.checkout }, { children: _jsx(CartItems, { cart: cart, selectedQuestion: assessedQuestionId, buyerForm: buyerForm, handleEditQuestion: handleEditQuestion, showQuestion: showQuestion, showSummary: showSummary, setShowQuestion: setShowQuestion, questionSubmitHistory: questionSubmitHistory, isSaving: isSaving, isMatrix: isMatrix, isCart: isCart, isCheckout: isCheckout, setShowRemoveAttendeeModal: setShowRemoveAttendeeModal, handleDeleteAttendee: handleDeleteAttendee, resetMobileFlow: resetMobileFlow, setCartTotalSeen: setCartTotalSeen, isAutoRegMode: isAutoRegMode, isMobile: isMobile, eventData: eventData, cartTotalSeen: cartTotalSeen }) })), cart && (_jsx(FadeSection, __assign({ fade: isCheckout }, { children: _jsx("div", __assign({ className: "p-right-well" }, { children: _jsx(CartCheckout, { cart: cart, currency: event === null || event === void 0 ? void 0 : event.currency, eventData: eventData, path: path, isCheckout: isCheckout, isMobile: isMobile }) })) })))] })), _jsx("div", __assign({ className: "cart-right".concat(isSaving ? " saving" : "", " ").concat((path === Constants.Routes.questions && hideQuestion) ||
                                (path === Constants.Routes.checkout && hideSummary)
                                ? "hiding"
                                : "") }, { children: _jsxs("div", __assign({ className: "cart-right-wrapper" }, { children: [(assessedQuestionId === (cart === null || cart === void 0 ? void 0 : cart.cartId)
                                        ? !buyerForm
                                        : !(attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.find(function (a) { return assessedQuestionId === a.id; }))) &&
                                        questionsStatus.isLoading &&
                                        !isMatrix &&
                                        !isCheckout &&
                                        !isCart && (_jsxs(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: assessedQuestionId === (cart === null || cart === void 0 ? void 0 : cart.cartId) && !isCheckout && !isCart }, { children: [_jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "35%" }) })), _jsx(Col, __assign({ xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }), _jsxs(Row, __assign({ className: "m-top-large" }, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "25%" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }))] }))), buyerForm && (_jsx(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: assessedQuestionId === (cart === null || cart === void 0 ? void 0 : cart.cartId) && !isCheckout && !isCart }, { children: _jsx(CartQuestionForm, { form: buyerForm, path: path, active: assessedQuestionId === (cart === null || cart === void 0 ? void 0 : cart.cartId) &&
                                                showForm &&
                                                !isCheckout &&
                                                !isCart, submitQuestions: submitQuestions, isSaving: isSaving, currency: event === null || event === void 0 ? void 0 : event.currency, isMobile: isMobile }) }))), attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.map(function (attendeeForm, index) { return (_jsx(WidgetSticky, __assign({ bottomOffset: 75, topOffset: 10, active: assessedQuestionId === attendeeForm.id && !isCheckout && !isCart }, { children: _jsx(CartQuestionForm, { form: attendeeForm, path: path, active: assessedQuestionId === attendeeForm.id &&
                                                showForm &&
                                                !isCheckout &&
                                                !isCart, submitQuestions: submitQuestions, isSaving: isSaving, currency: event === null || event === void 0 ? void 0 : event.currency, isAttendeeForm: true, attendeeForms: attendeeForms, lastForm: index + 1 === attendeeForms.length, isMobile: isMobile }, attendeeForm.id) }), attendeeForm.id)); }), cart && widgetPaymentRequest && (_jsxs(FadeSection, __assign({ fade: isCheckout || isCart }, { children: [_jsx("h4", __assign({ className: "h4 semi-bold py-3 m-bottom" }, { children: (cart === null || cart === void 0 ? void 0 : cart.total) === 0 ? "Complete your registration" : "Checkout Summary" })), renderCartTimeoutAlert(), _jsx(CartSummary, { showSummary: true, cart: cart, currency: event === null || event === void 0 ? void 0 : event.currency, eventData: eventData, path: path, isMobile: isMobile, widgetPaymentRequest: widgetPaymentRequest, returnToSummary: mobileGoBack })] })))] })) }))] })) : (_jsx(_Fragment, { children: _jsxs(Carousel, __assign({ selectedItem: mobileIndex, showThumbs: false, showArrows: false, showIndicators: false, showStatus: false, infiniteLoop: false, swipeable: true, emulateTouch: true, dynamicHeight: enableDynamicHeight, onSwipeStart: function (touchEvent) {
                            var _a, _b, _c, _d;
                            var swipeStart = 
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            //@ts-ignore
                            (_c = (_a = touchEvent === null || touchEvent === void 0 ? void 0 : touchEvent.clientX) !== null && _a !== void 0 ? _a : (_b = touchEvent.touches[0]) === null || _b === void 0 ? void 0 : _b.clientX) !== null && _c !== void 0 ? _c : (_d = touchEvent.changedTouches[0]) === null || _d === void 0 ? void 0 : _d.clientX;
                            setStartSwipe(swipeStart);
                        }, onSwipeEnd: function (touchEvent) {
                            var _a, _b, _c, _d;
                            var swipeEnd = 
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            //@ts-ignore
                            ((_c = (_a = touchEvent === null || touchEvent === void 0 ? void 0 : touchEvent.clientX) !== null && _a !== void 0 ? _a : (_b = touchEvent === null || touchEvent === void 0 ? void 0 : touchEvent.touches[0]) === null || _b === void 0 ? void 0 : _b.clientX) !== null && _c !== void 0 ? _c : (_d = touchEvent.changedTouches[0]) === null || _d === void 0 ? void 0 : _d.clientX) - (startSwipe !== null && startSwipe !== void 0 ? startSwipe : 0);
                            if (swipeEnd > 100) {
                                mobileGoBack();
                            }
                        }, swipeScrollTolerance: 999999999999, preventMovementUntilSwipeScrollTolerance: true }, { children: [_jsx("div", __assign({ className: "cart-carousel-item cart-items" }, { children: _jsx(CartItems, { cart: cart, selectedQuestion: assessedQuestionId, buyerForm: buyerForm, handleEditQuestion: handleEditQuestion, showQuestion: showQuestion, showSummary: showSummary, setShowQuestion: setShowQuestion, questionSubmitHistory: questionSubmitHistory, isSaving: isSaving, isMatrix: isMatrix, isCart: isCart, isCheckout: isCheckout, setShowRemoveAttendeeModal: setShowRemoveAttendeeModal, handleDeleteAttendee: handleDeleteAttendee, resetMobileFlow: resetMobileFlow, setCartTotalSeen: setCartTotalSeen, isAutoRegMode: isAutoRegMode, isMobile: isMobile, eventData: eventData, cartTotalSeen: cartTotalSeen }) })), _jsxs("div", __assign({ className: "cart-carousel-item has-react-select cart-mobile-questions" }, { children: [cart &&
                                        path === Constants.Routes.questions &&
                                        (currentCartAttendee || assessedQuestionId === cart.cartId) && (_jsxs("div", __assign({ className: "question-attendee-header" }, { children: [_jsx(IconButton, { classes: "question-attendee-header-back", icon: "arrow-left", ariaLabel: "Go back mobile", onClick: function () {
                                                    setShowQuestion(false);
                                                } }), currentCartAttendee ? (_jsx(AttendeeCartItem, { selectedQuestion: assessedQuestionId, cart: cart, attendee: currentCartAttendee, isSaving: isSaving, setShowRemoveAttendeeModal: setShowRemoveAttendeeModal, handleDeleteAttendee: handleDeleteAttendee, active: true })) : (_jsx("div", __assign({ className: "flex-1 attendee-wrapper-show" }, { children: _jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", { children: _jsx(StatusIndicator, { isComplete: cart.isCompleted, isSaving: isSaving && assessedQuestionId === cart.cartId, isPreRegistered: false, isGifted: false, isActive: true }) }), _jsx("h4", __assign({ className: "semi-bold m-0 flex-1" }, { children: "Just For You" }))] })) })))] }))), _jsxs("div", __assign({ className: "p" }, { children: [(assessedQuestionId === (cart === null || cart === void 0 ? void 0 : cart.cartId)
                                                ? !buyerForm
                                                : !(attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.find(function (a) { return assessedQuestionId === a.id; }))) &&
                                                questionsStatus.isLoading &&
                                                !isMatrix &&
                                                !isCheckout &&
                                                !isCart && (_jsxs(_Fragment, { children: [_jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "35%" }) })), _jsx(Col, __assign({ xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }), _jsxs(Row, __assign({ className: "m-top-large" }, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "25%" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }))] })), buyerForm && (_jsx(CartQuestionForm, { form: buyerForm, path: path, active: assessedQuestionId === (cart === null || cart === void 0 ? void 0 : cart.cartId) &&
                                                    showForm &&
                                                    !isCheckout &&
                                                    !isCart, submitQuestions: submitQuestions, isSaving: isSaving, currency: event === null || event === void 0 ? void 0 : event.currency, isMobile: isMobile })), attendeeForms === null || attendeeForms === void 0 ? void 0 : attendeeForms.map(function (attendeeForm, index) {
                                                return (_jsx(CartQuestionForm, { form: attendeeForm, path: path, active: assessedQuestionId === attendeeForm.id &&
                                                        showForm &&
                                                        !isCheckout &&
                                                        !isCart, submitQuestions: submitQuestions, isSaving: isSaving, currency: event === null || event === void 0 ? void 0 : event.currency, isAttendeeForm: true, attendeeForms: attendeeForms, lastForm: index + 1 === attendeeForms.length, isMobile: isMobile }, attendeeForm.id));
                                            })] }))] })), _jsx("div", __assign({ className: "cart-carousel-item cart-mobile-review" }, { children: _jsx(CartItems, { cart: cart, selectedQuestion: assessedQuestionId, buyerForm: buyerForm, handleEditQuestion: handleEditQuestion, showQuestion: showQuestion, showSummary: showSummary, setShowQuestion: setShowQuestion, questionSubmitHistory: questionSubmitHistory, isSaving: isSaving, isMatrix: isMatrix, isCart: isCart, isCheckout: isCheckout, setShowRemoveAttendeeModal: setShowRemoveAttendeeModal, handleDeleteAttendee: handleDeleteAttendee, resetMobileFlow: resetMobileFlow, setCartTotalSeen: setCartTotalSeen, isAutoRegMode: isAutoRegMode, isMobile: isMobile, eventData: eventData, cartTotalSeen: cartTotalSeen }) })), _jsx("div", __assign({ className: "cart-carousel-item has-react-select cart-mobile-summary" }, { children: cart && widgetPaymentRequest && (_jsxs(_Fragment, { children: [_jsx(AttendeeCartHeader, { showBack: true, onBackClick: function () { return setShowSummary(false); }, headerText: (cart === null || cart === void 0 ? void 0 : cart.total) === 0 ? "Complete your registration" : "Checkout Summary", resetMobileFlow: resetMobileFlow, setCartTotalSeen: setCartTotalSeen, showAdd: false }), renderCartTimeoutAlert(), _jsx(CartSummary, { showSummary: showSummary, cart: cart, currency: event === null || event === void 0 ? void 0 : event.currency, eventData: eventData, path: path, continueOverride: showSummary
                                                ? undefined
                                                : function () {
                                                    setShowSummary(true);
                                                }, isMobile: isMobile, widgetPaymentRequest: widgetPaymentRequest, returnToSummary: mobileGoBack })] })) })), _jsx("div", __assign({ className: "cart-carousel-item has-react-select cart-mobile-checkout" }, { children: cart && (_jsxs(_Fragment, { children: [_jsx(AttendeeCartHeader, { showBack: true, onBackClick: function () { return mobileGoBack(); }, showAdd: false, showClear: false, headerText: "Checkout Information", resetMobileFlow: resetMobileFlow, setCartTotalSeen: setCartTotalSeen }), renderCartTimeoutAlert(), _jsx(CartCheckout, { cart: cart, currency: event === null || event === void 0 ? void 0 : event.currency, eventData: eventData, path: path, isMobile: isMobile })] })) }))] })) }))] })) }));
};
export default Cart;
